import { useActionHandler, ActionHandlerOptions } from "./useActionHandler";
import { submitContactForm } from "@/server-side/actions/contact";
import { ContactFormData } from "@/server-side/types/common";

export function useContactActions() {
  const { handleAction } = useActionHandler();

  const submitContactFormAction = async (
    formData: ContactFormData,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(submitContactForm(formData), options);
  };

  return {
    submitContactForm: submitContactFormAction,
  };
}
